import React, { useState, useEffect } from 'react';
import { getPhoneValidationError } from '../utils/validation';

interface ValidatedPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  onValidChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  id?: string;
  name?: string;
  title?: string;
  style?: React.CSSProperties;
}

export const ValidatedPhoneInput: React.FC<ValidatedPhoneInputProps> = ({
  value,
  onChange,
  onValidChange,
  disabled,
  required,
  placeholder = "(555) 123-4567",
  id,
  name,
  title,
  style
}) => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const errorMessage = getPhoneValidationError(value);
    setError(errorMessage);
    if (!errorMessage && value.trim() !== '') {
      onValidChange(value);
    }
  }, [value, onValidChange]);

  return (
    <div style={{ position: 'relative', ...(style || { width: '100%' }) }}>
      <input
        className={`sky-field-input${error ? ' sky-field-error' : ''}`}
        id={id}
        name={name}
        type="tel"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        title={title}
        style={{ width: '100%', paddingRight: error ? 28 : undefined }}
      />
      {error && (
        <span style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', color: 'var(--red)', fontSize: 12, cursor: 'help' }} title={error}>✗</span>
      )}
    </div>
  );
};
